import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function JournalPage() {
  const [entries, setEntries] = useState([]);
  useEffect(() => { api.get("/journal").then(r => setEntries(r.data)); }, []);
  return (
    <div className="space-y-8" data-testid="journal-page">
      <div>
        <p className="eyebrow mb-1">Audit</p>
        <h1 className="text-3xl sm:text-4xl font-serif tracking-tight">Journal (append-only)</h1>
      </div>
      <div className="hairline font-mono text-xs">
        {entries.length === 0 && <p className="p-8 text-center text-muted-foreground">Aucune entrée.</p>}
        {entries.map((e, i) => (
          <div key={e.id} className={`px-5 py-3 grid grid-cols-[130px_100px_1fr_130px] gap-4 items-center ${i > 0 ? "border-t border-border" : ""}`} data-testid={`journal-${e.id}`}>
            <span className="text-muted-foreground">{new Date(e.created_at).toLocaleString()}</span>
            <span className="uppercase">{e.action}</span>
            <span>{e.entity_type} · <span className="text-muted-foreground">{e.entity_id.slice(0,8)}</span></span>
            <span className="text-right text-muted-foreground truncate">{e.actor_email}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
